import { render, staticRenderFns } from "./viewClient.vue?vue&type=template&id=72d87913&scoped=true&"
import script from "./viewClient.vue?vue&type=script&lang=js&"
export * from "./viewClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d87913",
  null
  
)

export default component.exports